<template>
  <div class="cate-nav">
    <div class="container">
      <div class="nav-con">
        <div class="all-categories hover-pointer" @mouseenter="showFirstList = true" @mouseleave="showFirstList = false">
          全部商品分类
        </div>
        <!-- <ul class="nav-item" v-if="showNavBar">
        <li
          class="nav-lis"
          v-for="(item, index) in navList.list"
          :key="index"
        >
          {{ item.name }}
        </li>
      </ul> -->
      </div>
      <!-- 全部商品分类 -->
      <div class="cate-list"  v-if="(!showAlways && showFirstList === true) || showAlways" @mouseenter="showFirstList = true" @mouseleave="showFirstList = false">
        <!-- 第一级分类 -->
        <div class="nav-side" @mouseleave="panel = false">
          <ul>
            <li v-for="(item, index) in cateList" :key="index" @mouseenter="showDetail(index)">
              <span class="nav-side-item" @click="goGoodsList(item.id)">{{
              item.name
            }}</span>
              <span v-for="(second, secIndex) in item.children" :key="secIndex">
                <span v-if="secIndex < 2"> / </span>
                <span @click="goGoodsList(second.id, second.parentId)" class="nav-side-item" v-if="secIndex < 2">{{ second.name }}</span>
              </span>
            </li>
          </ul>
        </div>
        <!-- 展开分类 -->
        <div class="detail-item-panel" v-show="panel" @mouseenter="panel = true" @mouseleave="panel = false">
          <div class="nav-detail-item">
            <template v-for="(item, index) in panelData">
              <span @click="goGoodsList(item.id, item.parentId)" v-if="index < 8" :key="index">{{ item.name }} <i class="el-icon-arrow-right"></i>
              </span>
            </template>
          </div>
          <ul>
            <li v-for="(items, index) in panelData" :key="index" class="detail-item-row">
              <span class="detail-item-title" @click="goGoodsList(items.id, items.parentId)">
                {{ items.name }} <i class="el-icon-arrow-right"></i>
                <span class="glyphicon glyphicon-menu-right"></span>
              </span>
              <div>
                <span v-for="(item, subIndex) in items.children" @click="goGoodsList(item.id, items.id, items.parentId)" :key="subIndex" class="detail-item">{{ item.name }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import { getCategory } from '@/api/goods'
import storage from '@/plugins/storage.js'
export default {
  name: 'GoodsListNav',
  props: {
    showAlways: {
      // 总是显示下拉分类
      default: true,
      type: Boolean
    },
    showNavBar: {
      // 显示全部商品分类右侧导航条
      default: true,
      type: Boolean
    },
    hover: {
      default: false,
      type: Boolean
    },
    large: {
      // 是否更高的高度
      default: false,
      type: Boolean
    },
    opacity: {
      // 是否背景透明
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      panel: false, // 二级分类展示
      panelData: [], // 二级分类数据
      showFirstList: false, // 始终展示一级列表
      cateList: [
        {
          brandList: null,
          children: [
            {
              brandList: null,
              children: [],
              commissionRate: 0,
              createBy: 'admin',
              createTime: '2022-03-16 09:45:20',
              deleteFlag: false,
              id: '1503910255578550274',
              image: '',
              level: 1,
              name: '二级分类',
              parentId: '1503910195730026497',
              parentTitle: null,
              sortOrder: 0,
              supportChannel: null,
              updateBy: null,
              updateTime: null
            }
          ],
          commissionRate: 0,
          createBy: 'admin',
          createTime: '2022-03-16 09:45:06',
          deleteFlag: false,
          id: '1503910195730026497',
          image: '',
          level: 0,
          name: '一级分类',
          parentId: '0',
          parentTitle: null,
          sortOrder: 0,
          supportChannel: null,
          updateBy: null,
          updateTime: null
        },
        {
          brandList: null,
          children: [
            {
              brandList: null,
              children: [
                {
                  brandList: null,
                  children: [{}],
                  commissionRate: 5,
                  createBy: null,
                  createTime: '2021-01-11 18:24:10',
                  deleteFlag: false,
                  id: '1348576427264204801',
                  image:
                    'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/1348576427264204801.png',
                  level: 2,
                  name: 'T恤',
                  parentId: '1348576427264204800',
                  parentTitle: null,
                  sortOrder: 0,
                  supportChannel: false,
                  updateBy: 'admin',
                  updateTime: '2021-11-16 17:56:31'
                },
                {
                  brandList: null,
                  children: [{}],
                  commissionRate: 5,
                  createBy: null,
                  createTime: '2021-01-11 18:24:10',
                  deleteFlag: false,
                  id: '1348576427264204801',
                  image:
                    'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/1348576427264204801.png',
                  level: 2,
                  name: '鞋子',
                  parentId: '1348576427264204800',
                  parentTitle: null,
                  sortOrder: 0,
                  supportChannel: false,
                  updateBy: 'admin',
                  updateTime: '2021-11-16 17:56:31'
                },
                {
                  brandList: null,
                  children: [{}],
                  commissionRate: 5,
                  createBy: null,
                  createTime: '2021-01-11 18:24:10',
                  deleteFlag: false,
                  id: '1348576427264204801',
                  image:
                    'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/1348576427264204801.png',
                  level: 2,
                  name: '裤子',
                  parentId: '1348576427264204800',
                  parentTitle: null,
                  sortOrder: 0,
                  supportChannel: false,
                  updateBy: 'admin',
                  updateTime: '2021-11-16 17:56:31'
                }
              ],
              commissionRate: 5,
              createBy: null,
              createTime: '2021-01-11 18:24:10',
              deleteFlag: false,
              id: '1348576427264204800',
              image: '',
              level: 1,
              name: '女装',
              parentId: '1348576427260010496',
              parentTitle: null,
              sortOrder: 0,
              supportChannel: false,
              updateBy: null,
              updateTime: '2021-03-02 01:03:17'
            }
          ],
          commissionRate: 1,
          createBy: null,
          createTime: '2021-01-11 18:24:10',
          deleteFlag: false,
          id: '1348576427260010496',
          image:
            'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/95b10dcf62b54ff890d65e57e8b99a62.jpg',
          level: 0,
          name: '服装',
          parentId: '0',
          parentTitle: null,
          sortOrder: 1,
          supportChannel: false,
          updateBy: 'admin',
          updateTime: '2022-03-07 10:07:47'
        },
        {
          brandList: null,
          children: [
            {
              brandList: null,
              children: [
                {
                  brandList: null,
                  children: [{}],
                  commissionRate: 5,
                  createBy: null,
                  createTime: '2021-01-11 18:24:10',
                  deleteFlag: false,
                  id: '1348576427264204801',
                  image:
                    'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/1348576427264204801.png',
                  level: 2,
                  name: 'T恤',
                  parentId: '1348576427264204800',
                  parentTitle: null,
                  sortOrder: 0,
                  supportChannel: false,
                  updateBy: 'admin',
                  updateTime: '2021-11-16 17:56:31'
                },
                {
                  brandList: null,
                  children: [{}],
                  commissionRate: 5,
                  createBy: null,
                  createTime: '2021-01-11 18:24:10',
                  deleteFlag: false,
                  id: '1348576427264204801',
                  image:
                    'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/1348576427264204801.png',
                  level: 2,
                  name: '鞋子',
                  parentId: '1348576427264204800',
                  parentTitle: null,
                  sortOrder: 0,
                  supportChannel: false,
                  updateBy: 'admin',
                  updateTime: '2021-11-16 17:56:31'
                },
                {
                  brandList: null,
                  children: [{}],
                  commissionRate: 5,
                  createBy: null,
                  createTime: '2021-01-11 18:24:10',
                  deleteFlag: false,
                  id: '1348576427264204801',
                  image:
                    'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/1348576427264204801.png',
                  level: 2,
                  name: '裤子',
                  parentId: '1348576427264204800',
                  parentTitle: null,
                  sortOrder: 0,
                  supportChannel: false,
                  updateBy: 'admin',
                  updateTime: '2021-11-16 17:56:31'
                }
              ],
              commissionRate: 5,
              createBy: null,
              createTime: '2021-01-11 18:24:10',
              deleteFlag: false,
              id: '1348576427264204800',
              image: '',
              level: 1,
              name: '女装222',
              parentId: '1348576427260010496',
              parentTitle: null,
              sortOrder: 0,
              supportChannel: false,
              updateBy: null,
              updateTime: '2021-03-02 01:03:17'
            }
          ],
          commissionRate: 1,
          createBy: null,
          createTime: '2021-01-11 18:24:10',
          deleteFlag: false,
          id: '1348576427260010496',
          image:
            'https://lilishop-oss.oss-cn-beijing.aliyuncs.com/95b10dcf62b54ff890d65e57e8b99a62.jpg',
          level: 0,
          name: '服装111',
          parentId: '0',
          parentTitle: null,
          sortOrder: 1,
          supportChannel: false,
          updateBy: 'admin',
          updateTime: '2022-03-07 10:07:47'
        }
      ] // 商品分类
    }
  },
  computed: {
    navList () {
      // 导航列表
      if (storage.getItem('navList')) {
        return JSON.parse(storage.getItem('navList'))
      } else {
        return []
      }
    }
  },
  methods: {
    getCate () {
      // 获取分类数据
      // if (this.hover) return false
      // getCategory(0).then((res) => {
      //   if (res.success) {
      //     this.cateList = res.result
      //     this.$store.commit('SET_CATEGORY', res.result)
      //     // 过期时间
      //     var expirationTime = new Date().setHours(new Date().getHours() + 1)
      //     // 存放过期时间
      //     localStorage.setItem('category_expiration_time', expirationTime)
      //     // 存放分类信息
      //     localStorage.setItem('category', JSON.stringify(res.result))
      //   }
      // })
    },
    showDetail (index) {
      // 展示全部分类
      this.panel = true
      this.panelData = this.cateList[index].children
    },
    goGoodsList (id, secondId, firstId) {
      // 分类共有三级，传全部分类过去
      const arr = [firstId, secondId, id]
      if (!arr[1]) {
        arr.splice(0, 2)
      }
      if (!arr[0]) {
        arr.shift()
      }
      let routerUrl = this.$router.resolve({
        path: '/info',
        query: { categoryId: arr.toString() }
      })
      window.open(routerUrl.href, '_blank')
    }
  },
  mounted () {
    console.log(localStorage.getItem('navList'))
  }
}
</script>

<style scoped lang="scss">
.nav-lis:hover {
  color: $theme_color !important;
  cursor: pointer;
}
.cate-nav {
  width: 100%;
  background: #fff;
  position: relative;
  margin: 0 auto;
  border-bottom: 2px solid red;
  // box-shadow: 1px 1px 1px red;
}
/** 商品分类 */
.nav-con {
  width: 1200px;
  height: 38px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  .all-categories {
    width: 200px;
    line-height: 40px;
    color: #fff;
    background-color: $theme_color;
    text-align: center;
    font-size: 16px;
    border-bottom: none;
  }
  .nav-item {
    width: 1000px;
    overflow: hidden;
    list-style: none;
    // background-color: #eee;
    display: flex;
    li {
      font-weight: bold;
      margin-left: 20px;
      color: rgb(129, 127, 127);
      font-size: 15px;
      &:hover {
        color: #e1251b;
      }
    }
  }
}
// 分类列表
.cate-list {
  margin: 0 auto;
  position: absolute;
  z-index: 1000;
}

.nav-side {
  width: 200px;
  float: left;
  padding: 0px;
  color: #fff;
  background-color: #fff;
  height: 402px;
  overflow: hidden;
  color: #333;
}
.nav-side ul {
  width: 100%;
  padding: 0px;
  margin: 8px 0px;
  list-style: none;
}
.nav-side li {
  padding: 7.5px 0px;
  padding-left: 10px;
  font-size: 13px;
  line-height: 18px;
  &:hover {
    background: #999395;
  }
}
.nav-side-item:hover {
  cursor: pointer;
  color: #e1251b;
}

/*显示商品详细信息*/
.detail-item-panel {
  width: 1000px;
  min-height: 402px;
  background-color: #fff;
  box-shadow: 0px 0px 15px #ccc;
  position: absolute;
  top: 0;
  left: 200px;
  z-index: 1000;
  box-sizing: border-box;
  padding: 15px;
  ul {
    margin: 0px;
    padding: 0px;
  }
}
.nav-detail-item {
  height: 40px;
  line-height: 40px;
  text-align: left;
  cursor: pointer;
  color: #eee;
}
.nav-detail-item span {
  padding: 6px;
  padding-left: 12px;
  margin-right: 15px;
  font-size: 12px;
  background-color: #6e6568;
}
.nav-detail-item span:hover {
  background-color: #e1251b;
}
.detail-item-panel li {
  line-height: 30px;
}
.detail-item-title {
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  color: #555555;
  padding: 6px;
  padding-left: 12px;
  margin-right: 15px;
  text-align: left;
}
.detail-item-title:hover {
  color: #e1251b;
}
.detail-item-row {
  display: flex;
  > div {
    display: flex;
    justify-content: start;
    align-items: center;
  }
}
.detail-item {
  font-size: 12px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  border-left: 1px solid #ccc;
  &:first-child {
    border: none;
    padding-left: 0;
  }
}
.detail-item:hover {
  color: #e1251b;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/CateNav.vue